var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGlasses(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 16,
    viewBox: "0 0 23 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.24211 1C4.97482 1 4.84117 1 4.72563 1.00894C3.36331 1.11436 2.24433 2.12702 2.00388 3.47208C1.98349 3.58617 1.97019 3.71915 1.9436 3.98511L1.26291 10.5904M9.24211 11H13.2421M9.24211 11C9.24211 13.2091 7.45133 15 5.24219 15C3.03305 15 1.24219 13.2091 1.24219 11C1.24219 8.79086 3.03305 7 5.24219 7C7.45133 7 9.24211 8.79086 9.24211 11ZM13.2421 11C13.2421 13.2091 15.033 15 17.2422 15C19.4513 15 21.2422 13.2091 21.2422 11C21.2422 8.79086 19.4513 7 17.2422 7C15.033 7 13.2421 8.79086 13.2421 11ZM17.2572 1C17.5244 1 17.6581 1 17.7736 1.00894C19.136 1.11436 20.2549 2.12702 20.4954 3.47208C20.5158 3.58617 20.5291 3.71915 20.5557 3.98511L21.2226 10.602",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlasses);
export default __webpack_public_path__ + "static/media/glasses.fa1c3bb609fb59b7289744d24325b8e7.svg";
export { ForwardRef as ReactComponent };